<div class="copyfield" (mouseenter)="setMarginOfInfoText()">
	<p class="label">{{ label | translate }}</p>
	<span [innerHtml]="value" class="copyfield-value" tabindex="0" role="button" (focus)="setMarginOfInfoText()" (keydown.space)="copyText($event)" (keydown.enter)="copyText($event)" (click)="copyText($event)"></span>
	<span class="info" #copyfieldInfo aria-live="polite" [style.margin-left]="marginLeft">{{ copyInfo | translate }}</span>
</div>
